import { IconPlus } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { useGetLinkedAccounts } from './useGetLinkedAccounts';
import { LinkedAccount } from '../../ui/linkedAccount/LinkedAccount';

export const LinkedAccountsSuccess = ({
    onLinkAnother,
    onDone
}: {
    onLinkAnother: () => void;
    onDone: () => void;
}) => {
    const linkedAccounts = useGetLinkedAccounts();

    return (
        <div className="space-y-l">
            <div className="space-y-s">
                {linkedAccounts.map((account) => (
                    <LinkedAccount key={account.accountId} account={account} />
                ))}
            </div>

            <button
                type="button"
                className="inline-flex items-center gap-xs text-s font-bold text-primary-40"
                onClick={onLinkAnother}
            >
                <FormattedMessage
                    id="_.bank_selection_modal.link_additional_account"
                    defaultMessage="Link an additional account"
                />
                <IconPlus className="size-[16px]" />
            </button>

            <Button
                variant="primary-rounded"
                className="w-full"
                onClick={onDone}
            >
                <FormattedMessage
                    id="_.bank_selection_modal.done"
                    defaultMessage="Done"
                />
            </Button>
        </div>
    );
};
